import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export const MedNecAnalytics: React.FC = () => {
  return (
    <Box sx={{ width: '100%', p: 3, display: 'flex', justifyContent: 'center' }}>
      <Paper sx={{ p: 4, maxWidth: 600, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Medical Necessity Analytics
        </Typography>
        <Typography variant="body1" color="text.secondary">
          This feature is under development.
        </Typography>
      </Paper>
    </Box>
  );
};

export default MedNecAnalytics;
